import { useEffect } from "react";
import Hero from "./sections/Hero";

import StrategicValues from "./sections/StrategicValues";
import Clients from "./sections/Clients";
import Solutions from "./sections/Solutions";
import HomeDemoCTA from "./sections/HomeDemoCTA";
import Stats from "./sections/Stats";
import ChatBot from "./components/ChatBot";
import { recordPageView } from "./lib/visitorTracking";
import { Toaster } from "react-hot-toast";

function App() {
  useEffect(() => {
    void recordPageView();
  }, []);

  return (
    <div className="App">
      <Toaster position="top-center" />
      <Hero />
      <ChatBot />

      <StrategicValues />

      <Solutions />

      <Clients />

      {/* <SuccessStories /> */}

      <Stats />

      <HomeDemoCTA />
    </div>
  );
}

export default App;
